import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
interface DreamStep {
  id: number;
  title: string;
  completed: boolean;
  completedDate: string | null;
}
interface DreamStepsModalProps {
  isOpen: boolean;
  onClose: () => void;
  dreamTitle: string;
  steps: DreamStep[];
}
export function DreamStepsModal({
  isOpen,
  onClose,
  dreamTitle,
  steps
}: DreamStepsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-39">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl mx-4 max-h-[80vh] overflow-hidden flex flex-col" data-id="element-40">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-41">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-42">{dreamTitle}</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-43">
            <X className="w-5 h-5" data-id="element-44" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-45">
          <div className="space-y-4" data-id="element-46">
            {steps.map((step, index) => <div key={step.id} className="border border-gray-200 rounded-lg p-4" data-id="element-47">
                <div className="flex items-start gap-3" data-id="element-48">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${step.completed ? 'bg-green-100' : 'bg-gray-100'}`} data-id="element-49">
                    {step.completed ? <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-50" /> : <span className="text-sm font-medium text-gray-600" data-id="element-51">
                        {index + 1}
                      </span>}
                  </div>
                  <div className="flex-1" data-id="element-52">
                    <h3 className="font-semibold text-gray-900" data-id="element-53">
                      {step.title}
                    </h3>
                    {step.completed && step.completedDate && <p className="text-xs text-gray-600 mt-1" data-id="element-54">
                        Concluído em {step.completedDate}
                      </p>}
                  </div>
                  <span className={`px-2 py-1 text-xs font-medium rounded ${step.completed ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-55">
                    {step.completed ? 'Concluído' : 'Pendente'}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}